<div class="container main-container">
  <button class="btn btn-primary" (click)="abrirCriarWindow()">Nova</button>
  <hr class="rounded" />
  <div id="contasGrid"></div>
</div>
<!-- <div id="contaWindow">
    <div #windowHeader>
    </div>
    <div style="overflow: hidden;" #windowContent>
    </div>
</div> -->
<jqxWindow
  #contaWindow
  [width]="600"
  [height]="400"
  [maxHeight]="500"
  [minHeight]="200"
  [maxWidth]="700"
  [minWidth]="200"
  [showCollapseButton]="true"
  [autoOpen]="false"
>
  <div #windowHeader>header</div>
  <div style="overflow: hidden" #windowContent>
    <form novalidate (ngSubmit)="cadastrar()" [formGroup]="userForm">
      <div class="form-group">
        <label class="col-md-2 control-label">Perfil</label>
        <select class="form-control" id="perfil" formControlName="perfil">
          <option></option>
          <option value="Administrador">Administrador</option>
          <option value="Editor">Editor</option>
        </select>
      </div>

      <div class="form-group">
        <label class="col-md-2 control-label">E-mail</label>
        <input
          class="form-control"
          id="email"
          type="text"
          placeholder="E-mail (requerido)"
          formControlName="email"
        />
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Senha</label>
        <input
          class="form-control"
          id="senha"
          type="text"
          placeholder="senha (requerido)"
          formControlName="senha"
        />
      </div>
      <div class="form-group">
        <label class="col-md-3 control-label">Confirmar senha</label>
        <input
          class="form-control"
          id="confirmarSenha"
          type="text"
          placeholder="confirmar senha (requerido)"
          formControlName="confirmarSenha"
        />
      </div>
      <div class="form-group">
        <div class="col-md-10">
          <span>
            <button
              class="btn btn-success"
              id="salvar"
              [disabled]="!userForm.valid"
              type="submit"
            >
              Salvar
            </button>
          </span>
        </div>
      </div>
    </form>
  </div>
</jqxWindow>

<jqxWindow
  #redefinirSenhaWindow
  [width]="600"
  [height]="400"
  [maxHeight]="500"
  [minHeight]="200"
  [maxWidth]="700"
  [minWidth]="200"
  [showCollapseButton]="true"
  [autoOpen]="false"
>
  <div #windowHeader>header</div>
  <div style="overflow: hidden" #windowContent>
    <form
      novalidate
      (ngSubmit)="redefinirSenha()"
      [formGroup]="redefinirSenhaForm"
    >
      <div class="form-group">
        <label class="col-md-2 control-label">Perfil</label>
        <input
          class="form-control"
          id="perfil"
          type="text"
          disabled
          formControlName="perfil"
        />
      </div>

      <div class="form-group">
        <label class="col-md-2 control-label">E-mail</label>
        <input
          class="form-control"
          id="email"
          type="text"
          disabled
          formControlName="email"
        />
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Senha</label>
        <input
          class="form-control"
          id="senha"
          type="text"
          placeholder="senha (requerido)"
          formControlName="senha"
        />
      </div>
      <div class="form-group">
        <label class="col-md-3 control-label">Confirmar senha</label>
        <input
          class="form-control"
          id="confirmarSenha"
          type="text"
          placeholder="confirmar senha (requerido)"
          formControlName="confirmarSenha"
        />
      </div>
      <div class="form-group">
        <div class="col-md-10">
          <span>
            <button
              class="btn btn-success"
              id="salvar"
              [disabled]="!redefinirSenhaForm.valid"
              type="submit"
            >
              Salvar
            </button>
          </span>
        </div>
      </div>
    </form>
  </div>
</jqxWindow>
